function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M1.0012 18.1063V17.7869C1.04805 16.8421 1.35087 15.9266 1.87844 15.1349C2.75657 14.1839 3.35769 13.0184 3.61875 11.7609C3.61875 10.7889 3.61875 9.80311 3.70364 8.83116C4.14226 4.15194 8.76895 0.916748 13.339 0.916748H13.4522C18.0223 0.916748 22.649 4.15194 23.1018 8.83116C23.1867 9.80311 23.1018 10.7889 23.1725 11.7609C23.4371 13.0214 24.0376 14.1904 24.9128 15.1488C25.4443 15.9335 25.7476 16.8456 25.7901 17.7869V18.0924C25.8216 19.3618 25.3845 20.5996 24.5591 21.5775C23.4685 22.721 21.9885 23.4324 20.3993 23.577C15.7394 24.0768 11.0378 24.0768 6.37778 23.577C4.79042 23.4261 3.31256 22.7158 2.21801 21.5775C1.40542 20.5989 0.974101 19.3684 1.0012 18.1063Z",
  stroke: "#172A3A",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M9.83012 28.4089C10.5582 29.3228 11.6275 29.9143 12.8012 30.0524C13.9749 30.1905 15.1563 29.8639 16.0839 29.1448C16.3692 28.9322 16.626 28.6849 16.848 28.4089",
  stroke: "#172A3A",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

function SvgNotification(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 31,
    viewBox: "0 0 27 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotification);
export default __webpack_public_path__ + "static/media/Notification.a06b24ec.svg";
export { ForwardRef as ReactComponent };